
const DESIGN_ID = '8f0af0eb-0000-0000-0000-mock00000006';
const OVERLAP = 142; // centiunits (1.42in)
const RAIL_WIDTH = 1746; // 17.46in, matches choice 284417 metadata
const HEIGHT = 480; // 4.8in, shared by all three parts

const designDocument = {
  ModularDesignType: 'WallStorage',
  Id: DESIGN_ID,
  DesignName: 'Mock Ryobi Wall Rail 2-Pack Bundle',
  Version: 1,
  ProductTypeId: 97,
  Sku: 342752715, // TODO: real single-SKU bundle Sku for the Wall Rail 2-pack
  Surface: null,
  Matrix: { Rows: 1, Columns: 10, Segments: null },
  Cart: [],
  IsLocked: false,
  ProductsHash: null,
  ProjectId: null,
  Created: '2026-01-01T00:00:00.000Z',
  LastModified: '2026-01-01T00:00:00.000Z',
  Products: [
    {
      InstanceId: 'ryobi-wall-rail-1',
      Type: 'Accessory',
      Sku: 342752715,
      Name: 'RYOBI Wall Rail',
      ChoiceId: 284417,
      Origin: {
        Row: 0, Column: 0, Height: HEIGHT, Width: RAIL_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 1,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'ryobi-wall-rail-2',
      Type: 'Accessory',
      Sku: 342752715,
      Name: 'RYOBI Wall Rail',
      ChoiceId: 284417,
      Origin: {
        Row: 0, Column: RAIL_WIDTH - OVERLAP, Height: HEIGHT, Width: RAIL_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 2,
      TargetArea: null,
      ChoiceBundle: null,
    },
  ],
};

const ryobiWallRailBundleMock = [
  {
    Id: DESIGN_ID,
    DesignDocument: JSON.stringify(designDocument),
  },
];

export default ryobiWallRailBundleMock;
